import { render, staticRenderFns } from "./WordLadder.vue?vue&type=template&id=2c0315d3&scoped=true"
import script from "./WordLadder.vue?vue&type=script&lang=js"
export * from "./WordLadder.vue?vue&type=script&lang=js"
import style0 from "./WordLadder.vue?vue&type=style&index=0&id=2c0315d3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0315d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c0315d3')) {
      api.createRecord('2c0315d3', component.options)
    } else {
      api.reload('2c0315d3', component.options)
    }
    module.hot.accept("./WordLadder.vue?vue&type=template&id=2c0315d3&scoped=true", function () {
      api.rerender('2c0315d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Visualisations/WordLadder.vue"
export default component.exports